import React, { Component } from 'react';
import { Helmet } from "react-helmet";

class About extends Component {
  componentDidMount() {
    document.getElementById('root').classList.remove('welcome');
    document.getElementById("root").classList.remove("affiliate");
    document.getElementById('foo').classList.add('overflow');
    window.loadd();
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Careers</title>
          <meta name="description" content="STech - Careers pages" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">
              <h1>Careers</h1>
              <h2>Are you a STech talent?</h2>
            </div>
          </div>
        </header>
        <section className="clearfix fadeInUp">
          <div className="container about">
            <div className="content">
              We are always looking for the next big thing. And who knows,
              that could be you.
              <br />
              Give us a shout, drop us a mail and tell us about yourself.
              <br /> <br />
              Email us:{" "}
              <a href="mailto:talent@stech.com">talent@stech.com</a>
              <br /> <br />
              <br />
              <div id="BambooHR-ATS" className="show" />
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default About
